/* eslint-disable */
import React from 'react'
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import Card from '@material-ui/core/Card'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'
import CardMedia from '@material-ui/core/CardMedia'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'



const Connect = (props) => {
    const fields = props.news && props.news.fields;
    const imageUrl = fields && fields.newsimage && fields.newsimage.fields && fields.newsimage.fields.file
        ? fields.newsimage.fields.file.url
        : '';
    return(
        <div>
            { props.news ? (
                <Card className="content-card" elevation={0}>
                    <CardMedia className="content-card-media"
                    image={imageUrl}
                    title={fields.title}
                    />
                    <CardContent className="content-card-content">
                    <span className="content-card-label">Article</span>
                    <Typography gutterBottom component="h3" className="content-card-title">
                        {fields.title}
                    </Typography>
                    </CardContent>
                    <CardActions className="content-card-actions">
                        <Typography component="div">
                            <Link to={{ pathname: '/articledetails/'+fields.slug}} style={{textDecoration:'none'}}>
                                <Button className="content-card-button" variant="contained">
                                    Read article
                                </Button>
                            </Link>
                        </Typography>
                    </CardActions>
                </Card>
            ) : null}
        </div>
    )
}
export default Connect



// WEBPACK FOOTER //
// ./src/components/News/News.js